import { css } from "@emotion/react";
import React from "react";
import { useSelected } from "slate-react";

const selectedLinkStyles = css`
  box-shadow: 0 0 0 3px #ddd;
`;

const LinkComponent = ({ attributes, children, element }) => {
  const selected = useSelected();

  return (
    <a
      {...attributes}
      css={selected ? selectedLinkStyles : undefined}
      href={element.url}
      rel="noreferrer"
      target="_blank"
    >
      {children}
    </a>
  );
};

const getTextAlignStyles = (align) => css`
  text-align: ${align || "inherit"};
`;

const getListStyles = (align) => css`
  list-style-position: inside;
  padding-inline-start: 0px;
  text-align: ${align || "inherit"};
`;

export const Element = (props) => {
  const { attributes, children, element } = props;
  const textAlignStyles = getTextAlignStyles(element.align);
  const listStyles = getListStyles(element.align);

  switch (element.type) {
    case "block-quote":
      return (
        <blockquote css={textAlignStyles} {...attributes}>
          {children}
        </blockquote>
      );
    case "bulleted-list":
      return (
        <ul css={listStyles} {...attributes}>
          {children}
        </ul>
      );
    case "numbered-list":
      return (
        <ol css={listStyles} {...attributes}>
          {children}
        </ol>
      );
    case "heading-one":
      return (
        <h1 css={textAlignStyles} {...attributes}>
          {children}
        </h1>
      );
    case "heading-two":
      return (
        <h2 css={textAlignStyles} {...attributes}>
          {children}
        </h2>
      );
    case "list-item":
      return (
        <li css={textAlignStyles} {...attributes}>
          {children}
        </li>
      );
    case "link":
      return <LinkComponent {...props} />;
    default:
      return (
        <p css={textAlignStyles} {...attributes}>
          {children}
        </p>
      );
  }
};

export const Leaf = ({ attributes, children, leaf }) => {
  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.code) {
    children = <code>{children}</code>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  if (leaf.underline) {
    children = <u>{children}</u>;
  }

  return <span {...attributes}>{children}</span>;
};
